import { useReducer, useRef } from 'react';
import reducer, { initialState } from './reducer';
import { pan, reset, startPan, zoom } from './actions';

const usePanAndZoomVideo = ({ zoomable }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const containerRef = useRef(null);

  const onMouseMoveInWindow = (event) => {
    event.preventDefault();
    dispatch(pan(event));
  };

  const onMouseUpInWindow = () => {
    containerRef.current.className = containerRef.current.className.split(
      ' '
    )[0];
    window.removeEventListener('mouseup', onMouseUpInWindow);
    window.removeEventListener('mousemove', onMouseMoveInWindow);
  };

  const onMouseDown = (event) => {
    if (zoomable) {
      containerRef.current.className += ' cursor-move';
      dispatch(startPan(event));
      window.addEventListener('mouseup', onMouseUpInWindow);
      window.addEventListener('mousemove', onMouseMoveInWindow);
    }
  };

  const onWheel = (event) => {
    if (event.deltaY !== 0 && zoomable && containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      dispatch(zoom(event, containerRect));
    }
  };

  const onReset = () => {
    return dispatch(reset());
  };

  return {
    ...state,
    containerRef,
    onReset,
    onMouseDown,
    onWheel,
  };
};

export default usePanAndZoomVideo;
